/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-parens */
/* eslint-disable*/
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { AuthContext, UIContext } from "../../../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import PlanManagementGrid from "./planManagementGrid/PlanManagementGrid.jsx";

import { Button, Tab, Tabs, Typography, Box } from "@material-ui/core";
import PropTypes from "prop-types";

import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import { useNavigate } from "react-router-dom";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { api } from "../../../../../utils/api";
import { trackPromise } from "react-promise-tracker";

import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { GROUP_NUMBER } from "../../../../../constants/groups";
import CircularLoader from "../../../../shared/loader/CircularLoader";
import { getPermissionsFromGroupOwner } from "../../../../../utils/getPermissionsFromGroupOwner";

const GreenSwitch = withStyles({
	switchBase: {
		color: "#359a4c",
		"&$checked": {
			color: "#359a4c"
		},
		"&$checked + $track": {
			backgroundColor: "rgba(40, 167, 69, 0.8)"
		}
	},
	checked: {},
	track: {
		backgroundColor: "rgb(60, 179, 113)"
	}
})(Switch);

const TabPanel = (props) => {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
};

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

const a11yProps = (index) => {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`
	};
};

const PlanManagement = () => {
	const [planCheckedStatus, setPlanCheckedStatus] = useState(false);
	const [coreActivePlans, setCoreActivePlans] = useState([]);
	const [loading, setLoading] = useState(true);
	const [inActivePlans, setInActivePlans] = useState([]);
	const [unuploadVEbPRemiums, setunuploadVEbPRemiums] = useState([]);
	const [expiredPlans, setExpiredPlans] = useState([]);
	const [value, setValue] = useState(0);
	const { setDashboardHeader } = useContext(UIContext);
	const queryGroupNumber = useRouteParam("gn");
	const navigate = useNavigate();

	const [tabsAndPanels, setTabsAndPanels] = useState({
		tabs: [],
		panels: []
	});

	// const { switchAddTabs, setSwitchAddTabs } = useState({ switch: "both", add: "both" });

	const { user, setUser } = useContext(AuthContext);

	const planManagementPermission = user
		? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.plan_control_menu.plan_management_sub.self
		: null;

	const handlePlanSwitchClick = (event) => {
		const { checked } = event.target;
		// console.log(" this is the check status", checked);

		setPlanCheckedStatus(checked);
		// handleTabsAndPanels();
		getPlans(checked);
		if (checked) {
			// fetch draft VEBs too
			unuploadVEbPRemium();
		}
	};

	const getPlans = useCallback(
		async (planCheckedStatus) => {
			setLoading(true);
			try {
				let plans;
				let VEBplans;
				const planQuery = { group_number: queryGroupNumber };

				// console.log("planCheckStatus (getPlans)", planCheckedStatus);

				if (planCheckedStatus) {
					plans = await trackPromise(api.plan.getVEBPlans(planQuery));

					// console.log("VEB Plans===>", plans);
				} else {
					plans = await trackPromise(api.plan.getPlans(planQuery));
					// console.log("Core Plans===>", plans);
				}

				// console.log("Plans===>", plans);

				const _activePlans = plans.filter((plan) => {
					// console.log("plan.status===>", plan);
					return plan.status === "ACTIVE";
				});
				// const uploadpremium=VEBplans.filter((plan)=>{
				// 	if(!VEBp)
				// })
				// console.log("_activePlans==>", _activePlans);
				// console.log("_activePlans==>", _activePlans[0]?.end_date);
				setCoreActivePlans(Object.assign([], _activePlans));

				const _inactivePlans = plans.filter((plan) => {
					return plan.status === "INACTIVE";
				});
				// console.log("_inactivePlans==>", _inactivePlans);
				// console.log("_inactivePlans==>", _inactivePlans[0]?.end_date);
				setInActivePlans(Object.assign([], _inactivePlans));

				const _expiredPlans = plans.filter((plan) => {
					return plan.status === "EXPIRED";
				});
				setExpiredPlans(Object.assign([], _expiredPlans));
			} catch (error) {
				// console.error("Error fetching plans:", error);
			} finally {
				setLoading(false);
			}
		},
		[queryGroupNumber, planCheckedStatus]
	);
	const unuploadVEbPRemium = useCallback(async () => {
		try {
			const VEBplans = await trackPromise(api.plan.getVEBPlans({ group_number: queryGroupNumber }));
			const uploadpremium = VEBplans.filter((plan) => {
				return plan.premium_amount === null;
			});
			setunuploadVEbPRemiums(Object.assign([], uploadpremium));
			// console.log("uploadpremium", uploadpremium);
		} catch (error) {
			// console.error("Error fetching veb plans", error);
		}
	}, [queryGroupNumber]);

	const handleLabelChange = (event, value) => {
		setValue(value);
	};

	const handleAddCorePlanClick = () => {
		const pathname = `/employer/plan/create-core-plan?gn=${queryGroupNumber}`;
		navigate(pathname);
	};

	const handleAddVebPlanClick = () => {
		const pathname = `/employer/plan/create-veb-plan?gn=${queryGroupNumber}`;
		navigate(pathname);
	};

	let tabs = [];
	let panels = [];

	// !coreVEBSwitchStatus is used to determine if the switch is off  => Core Plans

	// console.log("test", user);

	const handleTabsAndPanels = useCallback(() => {
		if (!planCheckedStatus && planManagementPermission) {
			tabs = [];
			panels = [];
			if (planManagementPermission?.core_section.active_plans_tab.view) {
				tabs.push({
					label: "Active Plans"
				});
				panels.push({
					tabLabel: "active",
					actionPlan: coreActivePlans
				});
			}
			if (planManagementPermission?.core_section.inactive_plans_tab.view) {
				tabs.push({ label: "Inactive Plans" });
				panels.push({
					tabLabel: "Inactive Plans",
					actionPlan: inActivePlans
				});
			}
			// setTabList(tabs);
			// setTabPanels(panels);

			setTabsAndPanels({
				tabs: tabs,
				panels: panels
			});
		} else if (planCheckedStatus && planManagementPermission) {
			tabs = [];
			panels = [];
			if (planManagementPermission?.veb_section.active_plans_tab.view) {
				tabs.push({
					label: "Active Plans"
				});
				panels.push({
					tabLabel: "active",
					actionPlan: coreActivePlans
				});
			}
			if (planManagementPermission?.veb_section.inactive_plans_tab.view) {
				tabs.push({ label: "Inactive Plans" });
				panels.push({
					tabLabel: "Inactive Plans",
					actionPlan: inActivePlans
				});
				tabs.push({ label: "Draft Plans" });

				panels.push({
					tabLabel: "Draft Plans",
					actionPlan: unuploadVEbPRemiums
				});
			}
			// setTabList(tabs);
			// setTabPanels(panels);
			setTabsAndPanels({
				tabs: tabs,
				panels: panels
			});
		}

		// console.log(tabsAndPanels, "tablists", tabsAndPanels);
	}, [planCheckedStatus, planManagementPermission, coreActivePlans, inActivePlans, unuploadVEbPRemiums]);

	useEffect(() => {
		if (queryGroupNumber) {
			// console.log("queryGroupNumber", queryGroupNumber);
			getPlans(planCheckedStatus);
			unuploadVEbPRemium();
		}
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.plan_management);
	}, [setDashboardHeader, getPlans, queryGroupNumber]);

	useEffect(() => {
		if (planManagementPermission) {
			handleTabsAndPanels();
			// console.log("calling");
		}
		// }, [planManagementPermission, planCheckedStatus]);
	}, [queryGroupNumber, planManagementPermission, handleTabsAndPanels, planCheckedStatus]);
	useEffect(() => {
		if (tabsAndPanels.tabs.length > 0 && tabsAndPanels.panels.length > 0) {
			setValue(0);
		}
	}, [planCheckedStatus, tabsAndPanels]);

	return (
		<div className="plan-management-container">
			<div className="pf-action-button-container" id="pf-action-button-container">
				{planManagementPermission && planManagementPermission.core_section.create && (
					<Button className="button-green" variant="contained" onClick={handleAddCorePlanClick}>
						<span className="button-label-with-icon">Add Core Plan</span>
						<span>
							<LocalHospitalIcon className="button-icon" />
						</span>
					</Button>
				)}
				{planManagementPermission && planManagementPermission.veb_section.create && (
					<Button className="button-green" variant="contained" onClick={handleAddVebPlanClick}>
						<span className="button-label-with-icon">Add VEB Plan</span>
						<span>
							<LocalHospitalIcon className="button-icon" />
						</span>
					</Button>
				)}
			</div>
			<div className="all-location-tab-container">
				{loading}
				<Box sx={{ width: "100%" }}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<Tabs
							value={value}
							onChange={handleLabelChange}
							aria-label="basic tabs example"
							TabIndicatorProps={{
								style: {
									border: "none",
									backgroundColor: "#558b2f"
								}
							}}
							className="glb-tab-panel"
						>
							{tabsAndPanels.tabs.length > 0 &&
								tabsAndPanels.tabs.map((tab, index) => (
									<Tab
										label={tab.label}
										className="glb-tab-label"
										{...a11yProps(index)}
										key={index}
									/>
								))}
							{/* <Tab label={"Active Plans"} className="glb-tab-label" {...a11yProps(0)} />
							<Tab label={"Inactive Plans"} className="glb-tab-label" {...a11yProps(1)} /> */}
							{/* <Tab label={"History"} className="glb-tab-label" {...a11yProps(1)} /> */}
						</Tabs>
					</Box>
					{/* {queryGroupNumber === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS ? (
						<div className="switch-container" id="switch-container">
							<Grid className="switch-grid-container" container spacing={1}>
								<Grid className="core-plan-switch-container" item>
									Core Plans
								</Grid>
								<Grid item>
									<GreenSwitch
										checked={planCheckedStatus}
										onChange={handlePlanSwitchClick}
										name="plan-switch"
									/>
								</Grid>
								<Grid className="veb-plan-switch-container" item>
									VEB Plans
								</Grid>
							</Grid>
						</div>
					) : queryGroupNumber === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS ? null : null} */}
					{queryGroupNumber !== GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS &&
					queryGroupNumber !== GROUP_NUMBER.PROGRESSIVE_LABORATORIES ? (
						<div className="switch-container" id="switch-container">
							{planManagementPermission &&
								(planManagementPermission.core_section.view ||
									planManagementPermission.veb_section.view) && (
									<Grid className="switch-grid-container" container spacing={1}>
										{planManagementPermission.core_section.view && (
											<Grid className="core-plan-switch-container" item>
												Core Plans
											</Grid>
										)}
										{planManagementPermission.core_section.view &&
											planManagementPermission.veb_section.view && (
												<Grid item>
													<GreenSwitch
														checked={planCheckedStatus}
														onChange={handlePlanSwitchClick}
														name="plan-switch"
													/>
												</Grid>
											)}
										{planManagementPermission.veb_section.view && (
											<Grid className="veb-plan-switch-container" item>
												VEB Plans
											</Grid>
										)}
									</Grid>
								)}
						</div>
					) : null}

					{tabsAndPanels.panels.length > 0 &&
						tabsAndPanels.panels.map((panel, index) => {
							// console.log("object", panel);
							return (
								<TabPanel value={value} index={index} key={index}>
									<PlanManagementGrid
										gridProps={panel.actionPlan}
										tabLabel={panel.tabLabel}
										getPlans={getPlans}
										coreVEBSwitchStatus={planCheckedStatus}
									/>
								</TabPanel>
							);
						})}
					{/* <TabPanel value={value} index={0}>
						<PlanManagementGrid
							gridProps={coreActivePlans}
							tabLabel={"Active"}
							getPlans={getPlans}
							coreVEBSwitchStatus={planCheckedStatus}
						/>
					</TabPanel>

					<TabPanel value={value} index={1}>
						<PlanManagementGrid
							gridProps={inActivePlans}
							tabLabel={"Inactive"}
							getPlans={getPlans}
							coreVEBSwitchStatus={planCheckedStatus}
						/>
					</TabPanel> */}
					{/* <TabPanel value={value} index={1}>
						<PlanManagementGrid gridProps={expiredPlans} tabLabel={"history"} />
					</TabPanel> */}
				</Box>
			</div>
		</div>
	);
};

export default PlanManagement;
